export const TERMS_AND_CONDITIONS_TEXT =
  'I agree to the Atlassian Cloud Terms of Service and acknowledge the Privacy Policy';

const PRIVACY_POLICY = 'privacyPolicy';
const TERMS_OF_SERVICE = 'termsOfService';

export const CONSENT_KEYS = [PRIVACY_POLICY, TERMS_OF_SERVICE];

export const CONSENT_SOURCE_PARTNER_PURCHASE_CENTER = 'PARTNER_PURCHASE_CENTER';

export const legalLinks = {
  termsOfUseUrl: 'https://www.atlassian.com/legal/customer-agreement',
  privacyPolicyUrl: 'https://www.atlassian.com/legal/privacy-policy',
  customerAgreementUrl: 'https://www.atlassian.com/legal/atlassian-customer-agreement#intro',
};

export const helpLegalLinks = {
  termsOfUseUrl: 'https://www.atlassian.com/legal/cloud-terms-of-service',
  privacyPolicyUrl: 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers',
};
